// RECARO Composites — the FRONTEND face of the client config seam. The '@client/config'
// vite alias resolves here in this fork (web/vite.config.js repoint — the
// fork's one sanctioned edit outside client-custom/).
//
// ONE SOURCE OF TRUTH: these values mirror ../config/client.config.js (the
// server face). The config suite asserts the two never drift — edit BOTH
// or the runner goes RED.

export const BRAND_NAME = 'RECARO Composites';
export const BRAND_TAGLINE = 'World Class Manufacturing and Engineering Systems';
export const BRAND_SUBTITLE = '';
export const APP_TITLE = 'RECARO Composites — Zebra Stride';
export const CUSTOMER_LABEL = 'Customer';

export const ADMIN_GROUP = 'site-admins';

// The site-switchers group — membership reveals the site switcher (see the
// server-side config). Mirrors client.config.js; the config suite checks.
export const SITE_SWITCH_GROUP = 'site-switchers';

// Workspaces — mirrors the server seam's workspacesEnabled (ON for this client).
export const WORKSPACES_ENABLED = true;
export const STORAGE_PREFIX = 'recaro-composites-za';

export const PROJECT_ISSUE_TYPE = 'Project';
export const MODULE_ISSUE_TYPE = 'Module';
export const LINK_TYPE_NAME = 'Hierarchy';

export const WPO_FIELD = 'customfield_10001';

export const ACCENT_RGB = { r: 245, g: 163, b: 0 };

export const CUSTOMS_ALLOWED_HOSTS = [];

// RECARO's own views of fields on the work item screen — the product's FIELD_VIEWS seam (work-items
// FieldView). Loaded through the '@client/customs' alias, never a relative path: web/vite.config.js
// reads this file (APP_TITLE) and Vite bundles its config — a relative import here would drag the
// view into it and the build fails. (Frontend only: the server face has no views.)
//   KIT Stock on Hand (MB52)   on the KIT screen (2026-10-20): where the KIT goes, its parts grouped by
//                              where they come from, each with its stock in the External Database
//                              Source "MB52 SAP Stock On Hand" — red where a bought-out part has none
//                              (m-boms/KitStockField.jsx). The field itself holds nothing.
export const FIELD_VIEWS = [
  { field: 'KIT Stock on Hand (MB52)', load: () => import('@client/customs/m-boms/KitStockField.jsx') },
];
